import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { makeStyles, withStyles, Theme, createStyles, useTheme } from '@material-ui/core/styles';
import styles from "./Common.module.scss"
import { data } from './local';
import moment from 'moment';
import { Typography, CardHeader, CardMedia, CardContent, Button, Container, Tab, Tabs, Grid, Chip, Avatar, Card, Paper } from '@material-ui/core';
import SearchBox from './SearchBox';
import { eventEmitter, getCategoryMap, getDraftMode, getIsEnabled, getNominatorHashedMail, getNominatorId, getToken, setIsAnonymous, setNominatorId, getdraftNominationDetails, setdraftNominationDetails, getNominatorName, getNominatorMail, setAutoSaveVal } from './common';
import clsx from 'clsx';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { deleteNominations, getDraftNominations, getReceivedNominations, getSubmittedNominations, insertNomination } from './services';
import { UserImage } from "./SearchBox";
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useSelector } from 'react-redux';
import { store } from '../store/store';
import { setRecievedNominations, setSentNominations } from "../actions/dashboardActions"
import { useLocation } from 'react-router-dom';
import { dashboardPath } from './constants';
import { appInsights } from "../AppInsights";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { style } from '@mui/system';
import { TRUE } from 'node-sass';
import { CommonAxisSettingsConstantLineStyle } from 'devextreme-react/chart';

import { NotificationAlert } from "./NotificationAlert";
import { LineScalePulseOut } from 'react-pure-loaders';
import { jsx } from '@emotion/react';

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: any;
    value: any;
}



export const NominationCards: FunctionComponent<any> = ({ token, showViewMore, showAll }: any) => {

    const [value, setValue] = React.useState(0);
    const [draftNominations, setDraftNominations] = useState<any>(null);
    const [submittedNominations, setSubmitttedNominations] = useState<any>(null);
    const [receivedNominations, setReceivedNominations] = useState<any>();

    const [year, setYear] = React.useState(new Date().getFullYear());
    const [open, setOpen] = React.useState(false);



    // Handlers
    const handleCloseLoader = () => {
        setOpen(false);
    };
    const handleToggleLoader = () => {
        setOpen(!open);
    };

    const handleYearChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setYear(event.target.value as any);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index: number) => {
        setValue(index);
    };
    const [nominatorId, setNominatorId] = useState<any>(null);
    useEffect(() => {
        eventEmitter.on("nominated", () => {
            if (token && nominatorId) {
                getNominations();
            }
        })
    }, [])
    useEffect(() => {
        if (token && nominatorId) {
            getNominations();
        }
    }, [token, nominatorId, year])

    const onDelete = (index: any) => {
        draftNominations.splice(index, 1);
        setDraftNominations([...draftNominations]);
    }

    const getNominations = async () => {

        handleToggleLoader();
        if (nominatorId) {

            setDraftNominations([]);

            var result: any = await getDraftNominations(nominatorId, year,getNominatorMail());
            result != "" ? setDraftNominations(result.nominations) : setDraftNominations([]);


            var submittedResult: any = await getSubmittedNominations(nominatorId, year,getNominatorMail());
            submittedResult != "" ? setSubmitttedNominations(submittedResult?.nominations) : setSubmitttedNominations([]);

            store.dispatch(!submittedResult ? setSentNominations(0) : setSentNominations(submittedResult?.nominations?.length))

            var receivedResult: any = await getReceivedNominations(nominatorId, year,getNominatorMail());
            receivedResult != "" ? setReceivedNominations(receivedResult?.nominations) : setReceivedNominations([]);
            if (receivedResult != "") {
                receivedResult.nominations.forEach((element: any) => {
                    if (element.isAnonymous == 'True') {
                        element.nominatorDetails.firstName = "Anonymous";
                        element.nominatorDetails.middleName = "";
                        element.nominatorDetails.lastName = "Nominator";
                        element.nominatorDetails.title = "";
                        element.nominatorDetails.city = "";
                        element.nominatorDetails.graphId = "";
                        element.title = "";
                        element.nominatorDetails.email="NA";
                    }
                });
            }
            handleCloseLoader();
            //setReceivedCount(receivedResult?.nominations?.length)
            // dispatchReceived({ payload: receivedResult?.nominations?.length});
            store.dispatch(!receivedResult ? setRecievedNominations(0) : setRecievedNominations(receivedResult?.nominations?.length))
        }
    }

    useEffect(() => {

        let checkNomitatorInterval = setInterval(() => {
            let nominatorId = getNominatorId();
            if (nominatorId) {
                setNominatorId(nominatorId)
                clearInterval(checkNomitatorInterval);
            }
        }, 500)

    }, [])
    const useStyles = makeStyles((theme: Theme) => ({
        root: {
            backgroundColor: theme.palette.background.paper,
            width: 500,
        },
    }));

    function a11yProps(index: any) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }

    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;
    const { nominationSection } = languageData[languageSelected];


    let history = useHistory();

    function handleClick(draftNomination: any) {
        setAutoSaveVal(draftNomination?.notes);
        setIsAnonymous(draftNomination?.isAnonymous);
        history.push("nominations", {
            id: draftNomination?.nomineeDetails?.graphId,
            token,
            name: draftNomination?.nomineeDetails?.lastName + "," + draftNomination?.nomineeDetails?.firstName + " " + draftNomination?.nomineeDetails?.middleName,
            jobTitle: draftNomination?.title,
            officeLocation: draftNomination?.nomineeDetails?.city,
            nomineeId: draftNomination.nomineeId,
            nomineeManagerName: draftNomination?.nomineeDetails?.managerName,
            nomineeManagerEmail: draftNomination?.nomineeDetails?.managerEmail,
            notes: draftNomination?.notes,
            isAnonymous: draftNomination?.isAnonymous,
            mail: draftNomination?.nomineeDetails?.email
        }

        )
    }

    function handleViewMore() {
        history.push("nomDashboard", {
            token,
            sent: submittedNominations?.length,
            received: receivedNominations?.length
        }
        )
    }



    const loc = useLocation();

    return (

        <Grid className={styles.nominationSection + " " + loc.pathname == dashboardPath ? styles.bgNone : ""}>
            <Grid item xs={12}>
                <Tabs centered
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label=" tabs "

                >
                    <Tab className={showViewMore ? styles.tabLite : styles.tabDark} label={nominationSection.draftTab} {...a11yProps(0)} />
                    <Tab className={showViewMore ? styles.tabLite : styles.tabDark} label={nominationSection.sentTab} {...a11yProps(1)} />
                    <Tab className={showViewMore ? styles.tabLite : styles.tabDark} label={nominationSection.receivedTab} {...a11yProps(2)} />
                </Tabs>
                <div>
                    <DateSelect showStyleDark={loc.pathname == dashboardPath ? true : false} handleYearChange={handleYearChange} year={year} />
                </div>
                <div className={styles.divLoader}>
                    <LineScalePulseOut
                        color={'#035295'}
                        loading={open}
                    />
                </div>
            </Grid>

            {!open && draftNominations && <NominationTabs showAll={showAll} index={0} isDraft={true} value={value} nominations={draftNominations} nominationSection={nominationSection} token={token} onDelete={onDelete} handleClick={handleClick} handleViewMore={handleViewMore} showViewMore={showViewMore} />}


            {!open && submittedNominations &&
                <NominationTabs index={1} isDraft={false} value={value} showAll={showAll} nominations={submittedNominations} nominationSection={nominationSection} token={token} onDelete={onDelete} handleClick={handleClick} handleViewMore={handleViewMore} showViewMore={showViewMore} />}

            {!open && receivedNominations &&
                <NominationTabs index={2} isDraft={false} value={value} showAll={showAll} nominations={receivedNominations} nominationSection={nominationSection} token={token} onDelete={onDelete} handleClick={handleClick} handleViewMore={handleViewMore} showViewMore={showViewMore} isRecieved={true} />}
        </Grid>
    )
}


const DraftCardMenu: FunctionComponent<any> = ({ token, draftNomination, index, onDeleteCallback }: any) => {
    let history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [alert, setAlert] = useState(false);
    const [alertContent, setAlertContent] = useState<any>('');
    const [alertType, setAlertType] = useState<any>('');
    const [openDelNomination, setOpenDelNomination] = React.useState(false);
    const [openLoader, setOpen] = React.useState(false);

    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;
    const { nominationSection } = languageData[languageSelected];

    /*Loader*/
    const handleCloseLoader = () => {
        setOpen(false);
    };
    const handleToggleLoader = () => {
        setOpen(!openLoader);
    };
    const onMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpenDelNomination(false);
        setdraftNominationDetails(null);
    };
    const handleEdit = (draftNomination: any) => {
        handleClick(draftNomination);
        setAnchorEl(null);
    };
    const handleDelete = () => {
        let draftNomination = getdraftNominationDetails();
        deleteNominations(draftNomination?.id).then((response: any) => {
            if (response) {
                setAlertContent(nominationSection.dialog.alertContent);
                setAlert(true);
                setAlertType('success');
            }
            handleCloseLoader();
            onDeleteCallback(index);
        });
        setTimeout(() => { setAlert(false); }, 4000);
        setAnchorEl(null);
    };
    function DeleteNomination() {
        handleDelete();
        setOpenDelNomination(false);
        handleToggleLoader();
    }
    function DeleteNominationHandler(draftNomination: any) {
        setdraftNominationDetails(draftNomination);
        setOpenDelNomination(true);
        setAnchorEl(null);
    }
    function handleClick(draftNomination: any) {
        setAutoSaveVal(draftNomination?.notes);
        history.push("nominations", {
            id: draftNomination?.nomineeDetails?.graphId,
            token,
            name: draftNomination?.nomineeDetails?.lastName + "," + draftNomination?.nomineeDetails?.firstName + " " + draftNomination?.nomineeDetails?.middleName,
            jobTitle: draftNomination?.title,
            officeLocation: draftNomination?.nomineeDetails?.city,
            nomineeId: draftNomination.nomineeId,
            nomineeManagerName: draftNomination?.nomineeDetails?.managerName,
            nomineeManagerEmail: draftNomination?.nomineeDetails?.managerEmail,
            notes: draftNomination?.notes,
            isAnonymous: draftNomination?.isAnonymous,
            mail: draftNomination?.nomineeDetails?.email
        }

        )
    }
    return (
        <>
            {alert && <NotificationAlert state={alert} notificationMessage={alertContent} alertType={alertType} />}
            <Dialog
                open={openDelNomination}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }} >
                {nominationSection.dialog.dlgTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {nominationSection.dialog.dlgContent}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={styles.messageBoxEditor} onClick={DeleteNomination} autoFocus>
                    {nominationSection.dialog.dlgYes}
                    </Button>
                    <Button className={styles.messageBoxEditor} onClick={handleClose}>{nominationSection.dialog.dlgNo}</Button>

                </DialogActions>
            </Dialog>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={onMenuClick}>
                <MoreVertIcon />
            </Button>
            <Menu
                id={"simple-menu"}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                // open={true}

                onClose={handleClose}
            >
                {getIsEnabled() ? <MenuItem onClick={() => handleEdit(draftNomination)}>{nominationSection.edit}</MenuItem> : ""}
                <MenuItem onClick={() => DeleteNominationHandler(draftNomination)}>{nominationSection.delete}</MenuItem>
            </Menu>
            <div>
            </div>
        </>
    );
}


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        paper: {
            padding: theme.spacing(1),
        },
    }),
);

export const NominationTabs = ({ isDraft, value, showAll, nominations, index, nominationSection, token, onDelete, isRecieved, handleClick, handleViewMore, showViewMore }: any) => {

    var nominationsToShow = true;
    const theme = useTheme();
    function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`full-width-tabpanel-${index}`}
                aria-labelledby={`full-width-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }


    return <>
        {nominations && <TabPanel value={value} index={index} dir={theme.direction}>
            <Grid container justify="center" alignItems="center" >
                {nominations.length > 0 ? nominationsToShow = true : nominationsToShow = false}
                {nominationsToShow && nominations && nominations.slice(0, showAll ? nominations.length : 3).map((draftNomination: any, key: any) => {
                    const user = draftNomination[isRecieved ? "nominatorDetails" : "nomineeDetails"]

                    return <Card className={styles.card}>
                        <CardHeader
                            className={styles.cardcontent}
                            avatar={
                                user.email != 'NA' && <UserImageByMail mail={user.email} token={token} />
                            }
                            action={
                                (isDraft ? <DraftCardMenu key={key} index={key} draftNomination={draftNomination} onDeleteCallback={onDelete} token={token} /> : null)
                            }
                            title={`${user.firstName} ${user.middleName} ${user.lastName}`}
                            content={user.title}

                            subheader={<div><span>{user.title.length < 100 ? user.title.padEnd(100 - user.title.length, " ") : user.title}    {user.city}  </span>
                                <span><br></br>{moment(draftNomination.modifiedOn).format('MMM Do YYYY')}</span>
                            </div>}
                        />
                        <CardContent2 nomination={draftNomination} />

                        {isDraft && <CardActions disableSpacing>
                            <Button className={styles.AddAwardeeBttn}  style={{ position: "absolute", borderRadius: "10%", bottom: "5px" }}  onClick={() => handleClick(draftNomination)}>{nominationSection.draftTab}</Button>
                        </CardActions>}
                        {/* {isDraft && getIsEnabled() && <CardActions disableSpacing>
                            <Button className={styles.AddAwardeeBttn}  style={{ position: "absolute", borderRadius: "10%", bottom: "5px" }}  onClick={() => handleClick(draftNomination)}>{nominationSection.draftTab}</Button>
                        </CardActions>} */}
                        {/* {isDraft && !getIsEnabled() && <CardActions disableSpacing>
                            <span className={styles.messageNominationClose}>{nominationSection.msgNotificationClose}</span>
                        </CardActions>} */}
                    </Card>
                })}
                {!nominationsToShow && <span className={styles.noEntries}>{nominationSection.noEntries}</span>}

            </Grid>
            {nominationsToShow && showViewMore &&
                <Grid container justify="center" alignItems="center">
                    <Button variant="outlined" className={styles.nominateViewBttn} onClick={handleViewMore}>{nominationSection.viewMoreBttn}</Button>
                </Grid>
            }
        </TabPanel>}
    </>
}



const NominationsWrapper = ({ token }: any) => {
    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;

    const { nominationSection } = languageData[languageSelected];


    return <Container id="cards" maxWidth={"xl"} className={styles.nominationSection} >
        <div >
            {/* <Typography className={styles.nominationHeader} >{nominationSection.title}</Typography> */}
            <NominationCards showViewMore={true} token={token} showAll={false} />
        </div>
    </Container>
}

const CardContent2 = (props: any) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [opendraftMessage, setOpendraftMessage] = React.useState(false);

    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;

    const { nominationSection } = languageData[languageSelected];

    const handleDraftMessage = () => {
        let draftMessage = props.nomination.notes;
        setOpendraftMessage(true);

    };
    const handleClose = () => {
        setOpendraftMessage(false);
    }
    const open = Boolean(anchorEl);

    return (
        <div className={styles.Notes}><CardContent>
            <Typography variant="body2" color="textSecondary" component="p"
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
            ><div className={styles.SpanNotes}>
                    {props.nomination.notes.length >= 150 ? props.nomination.notes.substring(0, 150) + "..." : props.nomination.notes}
                </div>
                <a hidden={props.nomination.notes.length >= 150 ? false : true} style={{ color: "#00338e", cursor: 'pointer' }} onClick={handleDraftMessage}>{nominationSection.viewMoreBttn}</a>
            </Typography>

        </CardContent>
            <Dialog
                open={opendraftMessage}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }}>
                    {"Nomination Message"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{whiteSpace:"pre-line"}}>
                        {props.nomination.notes}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={styles.messageBoxEditor} onClick={handleClose} autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}


const useStyles1 = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            //  margin: theme.spacing(1),
            minWidth: 120,
            float: 'right',
            marginTop: theme.spacing(-5),
        },
        [theme.breakpoints.down(850)]: {
            formControl: {
                //  margin: theme.spacing(1),
                minWidth: 10,
                float: 'inline-end',
                marginTop: theme.spacing(-0),


            },


            minWidth: 10,
            float: 'right',
            marginTop: theme.spacing(-100),
        },
        selectEmpty: {
            marginTop: theme.spacing(10),
            position: 'relative'
        },
    }),
);

const DateSelect = ({ showStyleDark, handleYearChange, year }: any) => {
    const classes = useStyles1();
    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;
    const { nominationSection } = languageData[languageSelected];

    const years: any = [];
    for (let i = 0; i < 4; i++) {
        years.push((new Date().getFullYear()+1) - +i)
    }

    return (
        <FormControl className={classes.formControl}>
            <InputLabel className={showStyleDark ? styles.nominationYearSelectorDark : styles.nominationYearSelectorLite} shrink id="demo-simple-select-placeholder-label-label">
                {nominationSection.year}
            </InputLabel>
            <Select
                labelId="demo-simple-select-placeholder-label-label"
                id="demo-simple-select-placeholder-label"
                value={year}
                onChange={handleYearChange}
                displayEmpty
                className={showStyleDark ? styles.nominationYearSelectorDark : styles.nominationYearSelectorLite}
            >
                {
                    years.map((year: any, key: number) => {
                        return <MenuItem key={key} value={year}>{year}</MenuItem>
                    })
                }

            </Select>
        </FormControl>

    );
}

export const UserImageByMail: FunctionComponent<any> = ({ mail, token }: any) => {

    const [image, setImage] = useState<any>();
    useEffect(() => {
      let url = `https://graph.microsoft.com/v1.0/users/${mail}/photo/$value`;
      let icon;
      (async () => {
        if (token && mail || mail!='NA' ) {
          icon = fetch(url, {
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + token,
              "Content-Type": "image/jpg"
            },
          }).then(async (response: any) => {
            if (response.ok) {
              return response.blob();
            }
            if (response?.status == 200) {
              let data = response.body
            }
          }).then((photoBlob: any) => {
            let icon;
            if (photoBlob) {
              icon = URL.createObjectURL(photoBlob);
              setImage(icon)
            } else {
              icon = "/images/758772.svg";
            }
          });
        }
      })();
    }, [mail, token])
    return image ? <img id={mail} style={{
      width: "44px",
      height: "inherit",
      margin: "auto",
      borderRadius: "50%",
      marginRight: "5px"
  
      // width: "39px",
      // borderRadius: "20px"
    }} src={image} alt="noImage" /> :
  
  
      <AccountCircleIcon style={{
        height: "50px",
        width: "50px",
        borderRadius: "20px"
      }} />
    // <div style={{
    //   width: "45px",
    //   height: "45px",
    //   borderRadius: "50%",
    //   background: "grey"
    // }}></div>
  
  
  }

export default NominationsWrapper